import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Card } from '../../ui/card';
import { Plus, Edit, Trash2, Zap, GripVertical } from 'lucide-react';

const ProjectsTab = ({ projects, openModal, handleDelete, handleReorderProjects }) => {
  const [draggedProjectId, setDraggedProjectId] = useState(null);
  const [dropTargetProjectId, setDropTargetProjectId] = useState(null);

  const moveProject = (draggedId, targetId) => {
    if (!draggedId || !targetId || draggedId === targetId) return;

    const nextProjects = [...projects];
    const draggedIndex = nextProjects.findIndex((project) => project.id === draggedId);
    const targetIndex = nextProjects.findIndex((project) => project.id === targetId);

    if (draggedIndex === -1 || targetIndex === -1) return;

    const [draggedProject] = nextProjects.splice(draggedIndex, 1);
    nextProjects.splice(targetIndex, 0, draggedProject);
    handleReorderProjects(nextProjects);
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">Gerenciar Projetos</h2>
        <Button onClick={() => openModal()} className="bg-orange-600 hover:bg-orange-700 text-white">
          <Plus className="w-4 h-4 mr-2" />Novo Projeto
        </Button>
      </div>
      <p className="mb-6 text-sm text-gray-500">Arraste os cards pela alça para definir a ordem exibida na landing page.</p>
      {projects.length === 0 ? (
        <Card className="p-12 text-center">
          <p className="text-gray-500 text-lg">Nenhum projeto cadastrado ainda.</p>
          <Button onClick={() => openModal()} className="mt-4 bg-orange-600 hover:bg-orange-700 text-white">
            Criar Primeiro Projeto
          </Button>
        </Card>
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, index) => (
            <Card
              key={project.id}
              draggable
              onDragStart={() => setDraggedProjectId(project.id)}
              onDragOver={(event) => {
                event.preventDefault();
                if (dropTargetProjectId !== project.id) setDropTargetProjectId(project.id);
              }}
              onDrop={(event) => {
                event.preventDefault();
                moveProject(draggedProjectId, project.id);
                setDraggedProjectId(null);
                setDropTargetProjectId(null);
              }}
              onDragEnd={() => {
                setDraggedProjectId(null);
                setDropTargetProjectId(null);
              }}
              className={`overflow-hidden transition-all ${dropTargetProjectId === project.id ? 'ring-2 ring-orange-400 shadow-xl' : 'hover:shadow-lg'} ${draggedProjectId === project.id ? 'opacity-60' : ''}`}
            >
              <div className="relative h-48">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover" />
                <div className="absolute left-2 top-2 flex items-center gap-2">
                  <span className="rounded-lg bg-black/70 px-2.5 py-1 text-xs font-semibold text-white">
                    #{index + 1}
                  </span>
                  <span className="px-3 py-1 bg-orange-600 text-white text-sm font-semibold rounded-lg">
                    {project.category}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex space-x-2">
                  <div
                    className="p-2 bg-white rounded-lg shadow cursor-grab active:cursor-grabbing"
                    title="Arrastar para reordenar"
                  >
                    <GripVertical className="w-4 h-4 text-gray-700" />
                  </div>
                  <button
                    onClick={() => openModal(project)}
                    className="p-2 bg-white rounded-lg shadow hover:bg-gray-100 transition-colors"
                  >
                    <Edit className="w-4 h-4 text-gray-700" />
                  </button>
                  <button
                    onClick={() => handleDelete(project.id)}
                    className="p-2 bg-white rounded-lg shadow hover:bg-red-100 transition-colors"
                  >
                    <Trash2 className="w-4 h-4 text-red-600" />
                  </button>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-800 mb-2">{project.title}</h3>
                <p className="text-gray-600 text-sm mb-3 line-clamp-2">{project.description}</p>
                <div className="flex items-center text-orange-600">
                  <Zap className="w-4 h-4 mr-1" />
                  <span className="font-semibold">{project.power}</span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsTab;
